import { render, staticRenderFns } from "./RoutingStatusTable.vue?vue&type=template&id=283b5c26&scoped=true&"
import script from "./RoutingStatusTable.vue?vue&type=script&lang=js&"
export * from "./RoutingStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./RoutingStatusTable.vue?vue&type=style&index=0&id=283b5c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b5c26",
  null
  
)

export default component.exports